import { render, staticRenderFns } from "./contracts.vue?vue&type=template&id=a744a2f6&"
import script from "./contracts.vue?vue&type=script&lang=js&"
export * from "./contracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports